import { $, $$ } from '../dom';
import axios from 'axios';
const AUTOCOMPLETE_CONTAINER_SELECTOR = ".js-autocomplete__container";
const FORM_SELECTOR = '.js-autocomplete-search';
const KEYWORD_INPUT_SELECTOR = '.js-keywords-search';
const AUTOCOMPLETE_OPTIONS_SELECTOR = '.js-autocomplete-options';
const DATE_SORT_BUTTON_SELECTOR = '.js-date-sort-button';
const RELEVANCE_SORT_BUTTON_SELECTOR = '.js-relevance-sort-button';
const SORT_BUTTON_VALUE_SELECTOR = '.js-sort-button-value';

const FOCUS_SEARCH_INPUT_SELECTOR = '.js-focus-search-input';
const FOCUS_SEARCH_INPUT_FIELD_SELECTOR = '.js-focus-search-input--field';

export class Search {

    private _sorting: [string,string];
    private readonly _form: HTMLFormElement;
    private readonly _keywords: HTMLInputElement;
    private readonly _autocomplete_options: HTMLLIElement;
    private readonly _date_sort_button: HTMLButtonElement;
    private readonly _relevance_sort_button: HTMLButtonElement;
    private readonly _sort_button_value: HTMLInputElement;

    public constructor(el: HTMLElement) {
        this._form = <HTMLFormElement>$(FORM_SELECTOR, el);
        this._keywords = <HTMLInputElement>$(KEYWORD_INPUT_SELECTOR, el);
        this._autocomplete_options = <HTMLLIElement>$(AUTOCOMPLETE_OPTIONS_SELECTOR, el);
        this._date_sort_button = <HTMLButtonElement>$(DATE_SORT_BUTTON_SELECTOR, el);
        this._relevance_sort_button = <HTMLButtonElement>$(RELEVANCE_SORT_BUTTON_SELECTOR, el);
        this._sort_button_value = <HTMLInputElement>$(SORT_BUTTON_VALUE_SELECTOR, el);
        this._sorting = this.parseSorting(this._sort_button_value.value);
        this.getResults();
    }

   private renderDatalist(data): void {
       // Remove the datalist element if already present
       let datalist = document.getElementById("autocomplete-data")!;
        if (datalist && datalist.children.length > 0) {
            while (datalist.firstChild) {
                if(datalist.lastChild) {
                    datalist.removeChild(datalist.lastChild);
                }
            }
        }
        // Create fragment for option elements
        let fragment = document.createDocumentFragment();

        // Create list options
        for (let searchData of data) {
            let option = document.createElement('li');
            option.classList.add('js-autocomplete-options');
            option.textContent = searchData;
            fragment.append(option);
        }
        // Add options to datalist
        datalist.append(fragment);

        // Inject into the DOM
        this._keywords.after(datalist);

       const liSelector: HTMLCollectionOf<Element> = document.getElementsByClassName("js-autocomplete-options");
       Array.from(liSelector).forEach((element) => {
           element.addEventListener('click', (event) => {
               let selectedValue = event.target as HTMLLIElement;
               this._keywords.value = selectedValue.innerHTML;
               this._form?.submit();
           });
       });
    }

    getResults(): any {
        let source;
        this._keywords.addEventListener("input", async (event) => {
            const inputField = event.target as HTMLInputElement;
            // Check if a CancelToken.source has been assigned to the source variable, then call the cancel method when true.
            if (source) source.cancel('Operation canceled by the user.');

            // Assign the source factory to the source variable
            source = axios.CancelToken.source();

            const option = {
                cancelToken: source.token,// add the cancel token, as an option for the request
                headers: {
                    Accept: 'application/json',
                },
            };

            this._keywords.classList.add('loading');
            axios.get(
                `https://wmr.lndo.site/wp-json/zmp_search_block/v1/get_autocomplete?keyword=${inputField.value}`,
                option
            ).then((result: any) => {
                this.renderDatalist(result.data);
                this._keywords.classList.remove('loading');
            }).catch((error) => {
                if (axios.isCancel(error)) {
                    console.log('Request canceled', error.message);
                } else if (axios.isAxiosError(error)) {
                    console.log('error message: ', error.message);
                } else {
                    console.log('unexpected error: ', error);
                }
            });
        });
        this._date_sort_button.addEventListener('click', e => {
            this.setSorting((e.target as HTMLButtonElement).value);
        });
        this._relevance_sort_button.addEventListener('click', e => {
            this.setSorting((e.target as HTMLButtonElement).value);
        });
    }

    private setSorting(value:string): void{
        this._sorting = [value,value===this._sorting[0] ? this.getAlternateSortDirection(this._sorting[1]) : this._sorting[1]];
        this.setSortValue();
    }

    private getAlternateSortDirection(sortBy:string): string{
        return sortBy === 'ASC' ? 'DESC' : 'ASC';
    }

    private parseSorting(value: string): [string,string] {
        const sorting = value.split(':');
        if(sorting.length > 1) {
           return [sorting[0],sorting[1]];
        }
        return ['score','DESC'];
    }

    private setSortValue(): void {
        this._sort_button_value.value = `${this._sorting[0]}:${this._sorting[1]}`;
    }
}
export function search(): void {
    $$(AUTOCOMPLETE_CONTAINER_SELECTOR).forEach((search: HTMLElement): void => {
        new Search(search);
    });
}


export function searchInputFocus(): void {
    const search = $<HTMLDivElement>(FOCUS_SEARCH_INPUT_SELECTOR);

    search?.addEventListener('click', e => {
        const field = $<HTMLInputElement>(FOCUS_SEARCH_INPUT_FIELD_SELECTOR, search);
        field?.focus();
    });

}
